import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import {
  selectIsAuthenticated,
  useAuthStore,
} from '@/features/auth/store/auth.store'
import { AUTH_STORAGE_KEYS } from '@/features/auth/constants/auth.constants'
import { APP_ROUTES } from '@/shared/constants/routes.constants'

interface PublicOnlyRouteProps {
  children: ReactNode
}

/**
 * Gate for pages that only authenticated users should *not* see (login,
 * signup, forgot / reset password). If the user already has a session, they
 * are bounced back to the dashboard or a previously requested path.
 */
export default function PublicOnlyRoute({ children }: PublicOnlyRouteProps) {
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  const status = useAuthStore((s) => s.status)

  if (status === 'hydrating') return null

  if (isAuthenticated) {
    const requested = localStorage.getItem(AUTH_STORAGE_KEYS.REQUESTED_PATH)
    if (requested) localStorage.removeItem(AUTH_STORAGE_KEYS.REQUESTED_PATH)
    return <Navigate to={requested || APP_ROUTES.DASHBOARD_HOME} replace />
  }

  return <>{children}</>
}
